// ds-delivery-why.js — el motivo del retraso en la línea del carrito.
//
// El markup lo emite ds-delivery-estimate.liquid (contexto 'line'): un botón
// con `popovertarget` y un <span popover> con el texto. El botón ya abre y
// cierra el popover SIN JavaScript —eso lo hace el navegador, y de ahí salen
// gratis el cierre con Esc, el clic fuera y el teclado—, así que este fichero
// solo añade lo que el atributo no cubre:
//
//   1. Abrir al pasar el ratón, y CERRAR al retirarlo (spec D2). Sin lo
//      segundo, rozar el icono de camino a otro sitio dejaba una tarjeta
//      flotando sobre la línea siguiente que además se tragaba sus clics.
//   2. Colocarlo junto a su botón. Un popover sin coordenadas se centra en la
//      pantalla; CSS anchor positioning lo resolvería, pero Firefox no lo
//      soporta todavía (spec D5).
//   3. Cerrarlo si su botón deja de estar a la vista al hacer scroll: si no,
//      el tooltip se quedaba clavado arriba, sin nada debajo a lo que referirse.
//
// Quien declara que el navegador soporta popover NO es este fichero, sino el
// script en línea de ds-delivery-strings.liquid, en el <head>: aquí llegaría
// tarde —va con `defer`— y el icono aparecería después del primer pintado,
// ensanchando la fila (spec D7-bis).
//
// Todo delegado en `document` y sin estado por botón: el drawer del carrito se
// reinyecta ENTERO por AJAX al cambiar cantidades, y cualquier cosa atada a un
// botón concreto se iría con él.
(function () {
  'use strict';

  if (!Object.prototype.hasOwnProperty.call(HTMLElement.prototype, 'popover')) return;

  var BOTON = '.ds-delivery-estimate__why';
  var TEXTO = 'ds-delivery-estimate__why-text';
  var MARGEN = 8; // separación con el botón y con el borde de la pantalla

  function popoverDe(boton) {
    var id = boton && boton.getAttribute('popovertarget');
    return id ? document.getElementById(id) : null;
  }

  function botonDe(texto) {
    var id = window.CSS && CSS.escape ? CSS.escape(texto.id) : texto.id;
    return document.querySelector('[popovertarget="' + id + '"]');
  }

  function abierto(texto) {
    try {
      return texto.matches(':popover-open');
    } catch (e) {
      return false;
    }
  }

  // `medido` a false cuando el popover todavia no esta pintado (en
  // `beforetoggle` es 0x0 y no hay nada que medir). Ahi se coloca a ojo con lo
  // unico que SI se sabe —el ancho, que el CSS fija— y dando por hecho que cabe
  // debajo, que es el caso normal. Con eso el primer fotograma sale ya en su
  // sitio en vez de en la esquina, y el `toggle` posterior lo corrige si hacia
  // falta volcarlo arriba.
  function colocar(texto) {
    var boton = botonDe(texto);
    if (!boton) return;
    var b = boton.getBoundingClientRect();
    if (!b.width) return;

    var t = texto.getBoundingClientRect();
    var medido = t.width > 0;
    if (!medido) {
      // getComputedStyle sí resuelve el ancho de un elemento display:none.
      var anchoCss = parseFloat(getComputedStyle(texto).width);
      if (!anchoCss) return;
      t = {width: anchoCss, height: 0, top: 0, bottom: 0};
    }

    var ancho = document.documentElement.clientWidth;
    var alto = document.documentElement.clientHeight;

    // Centrado bajo el botón, y metido dentro de la pantalla si se sale.
    var izquierda = b.left + b.width / 2 - t.width / 2;
    var tope = ancho - t.width - MARGEN;
    if (izquierda > tope) izquierda = tope;
    if (izquierda < MARGEN) izquierda = MARGEN;

    // Si abajo no cabe, encima del botón. Sin medir todavía no se puede saber:
    // se deja debajo y el `toggle` lo vuelca si hace falta.
    var arriba = b.bottom + MARGEN;
    if (medido) {
      if (arriba + t.height > alto - MARGEN) arriba = b.top - t.height - MARGEN;
      if (arriba < MARGEN) arriba = MARGEN;
    }

    texto.style.left = Math.round(izquierda) + 'px';
    texto.style.top = Math.round(arriba) + 'px';
  }

  // `beforetoggle`, no `toggle`: el primero es SÍNCRONO y llega antes de que el
  // navegador pinte. Con `toggle` el popover se veía un fotograma en la esquina
  // superior izquierda, que es donde está sin coordenadas, antes de saltar a su
  // sitio. Se coloca en los dos por si el navegador solo trae uno.
  function alAbrir(e) {
    var texto = e.target;
    if (!texto || !texto.classList || !texto.classList.contains(TEXTO)) return;
    if (e.newState !== 'open') return;
    colocar(texto);
  }
  document.addEventListener('beforetoggle', alAbrir, true);
  document.addEventListener('toggle', alAbrir, true);

  // ---- Ratón ----
  // El discriminador es el puntero DEL EVENTO, no la capacidad del equipo:
  // `(hover: hover)` describe el puntero PRIMARIO, así que en un portátil
  // táctil con ratón daba `true` y un toque con el dedo abría el popover en
  // `pointerover`… para que el `click` del mismo toque lo cerrara por toggle.
  // El comprador tocaba el icono y no veía nada.
  function esRaton(e) {
    return e.pointerType === 'mouse' || e.pointerType === 'pen';
  }

  document.addEventListener('pointerover', function (e) {
    if (!esRaton(e)) return;
    var boton = e.target && e.target.closest && e.target.closest(BOTON);
    if (!boton) return;
    var texto = popoverDe(boton);
    if (!texto || typeof texto.showPopover !== 'function') return;
    // Ya abierto: showPopover() lanzaría InvalidStateError.
    if (abierto(texto)) return;
    try {
      texto.showPopover();
    } catch (err) {
      /* otra cosa lo abrió entre medias; no hay nada que hacer */
    }
  });

  // Cerrar al salir. Se mira `relatedTarget` —a dónde va el puntero— porque el
  // tooltip puede quedar bajo el ratón: si el puntero pasa del botón al propio
  // texto, no se cierra, para que se pueda seleccionar y leer.
  document.addEventListener('pointerout', function (e) {
    if (!esRaton(e)) return;
    var boton = e.target && e.target.closest && e.target.closest(BOTON);
    var texto = boton
      ? popoverDe(boton)
      : e.target && e.target.closest && e.target.closest('.' + TEXTO);
    if (!texto || !abierto(texto)) return;

    var hacia = e.relatedTarget;
    if (hacia && hacia.closest) {
      var sigueDentro = hacia.closest('.' + TEXTO) === texto || popoverDe(hacia.closest(BOTON)) === texto;
      if (sigueDentro) return;
    }
    if (typeof texto.hidePopover === 'function') {
      try {
        texto.hidePopover();
      } catch (err) {
        /* ya estaba cerrado */
      }
    }
  });

  // ---- Scroll y resize ----
  // Unas coordenadas fijas dejan de corresponder con su botón en cuanto algo se
  // mueve. Mientras el botón siga a la vista se recolocan; en cuanto sale del
  // viewport se cierra, para no dejar la tarjeta flotando huérfana sobre la
  // cabecera.
  function repasarAbiertos() {
    var abiertos = document.querySelectorAll('.' + TEXTO + ':popover-open');
    for (var i = 0; i < abiertos.length; i++) {
      var texto = abiertos[i];
      var boton = botonDe(texto);
      var b = boton && boton.getBoundingClientRect();
      var visible =
        b && b.bottom > 0 && b.top < document.documentElement.clientHeight && b.width > 0;
      if (!visible) {
        if (typeof texto.hidePopover === 'function') {
          try {
            texto.hidePopover();
          } catch (err) {
            /* ya estaba cerrado */
          }
        }
        continue;
      }
      colocar(texto);
    }
  }
  // En captura, porque el scroll que importa es el INTERNO del drawer
  // (.cart-items-wrapper), y ese evento no burbujea hasta window.
  window.addEventListener('scroll', repasarAbiertos, true);
  window.addEventListener('resize', repasarAbiertos);
})();
